import Vue from 'vue'
import Vuex from 'vuex'
import _find from 'lodash/find'
import Shopify from 'shopify-buy'
import Prismic from 'prismic.io'
import Config from 'src/config'

Vue.shopClient = Shopify.buildClient({
  domain: process.env.SHOPIFY.DOMAIN,
  storefrontAccessToken: process.env.SHOPIFY.TOKEN
})
const shop = Vue.shopClient

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    site: null,
    collections: [],
    checkout: { lineItems: [] },
    shopCollections: []
  },
  mutations: {
    setInitialDocs (state, docs) {
      for (var i = 0; i < docs.length; i++) {
        if (docs[i].type === 'site') state.site = docs[i]
        else if (docs[i].type === 'collection') state.collections.push(docs[i])
      }
    },
    setCheckout (state, checkout) {
      state.checkout = checkout
    },
    addShopCollection (state, collection) {
      state.shopCollections.push(collection)
    }
  },
  actions: {
    getInitialDocs ({ commit, state }) {
      Prismic.api(Config.prismic.api_url).then((api) => {
        return api.query(
          Prismic.Predicates.any('document.type', ['site', 'collection']),
          {pageSize: 100, orderings: '[my.collection.number]'}
        )
      }).then((resp) => commit('setInitialDocs', resp.results))
      .catch(err => console.error('Error: Get Initial Docs failed', err))
    },
    getShopCollection ({ commit, state }, id) {
      if (!id) return Promise.reject(new Error('No Collection ID specified'))
      // format id
      id = Vue.getShopifyID(id, 'Collection')
      // check if already store
      const stored = _find(state.shopCollections, ['id', id])
      if (stored) return false
      // otherwise fetch it
      shop.collection.fetchWithProducts(id).then((collection) => {
        // console.log('Fetched collection: ', collection)
        commit('addShopCollection', collection)
      })
    },
    createCheckout ({ dispatch, commit, state }) {
      const savedId = localStorage.getItem('checkoutId')
      if (savedId) {
        return shop.checkout.fetch(savedId).then((checkout) => {
          // Check if cart already completed
          if (!checkout || checkout.completedAt) {
            console.log('Cart already completed. Creating new...')
            localStorage.removeItem('checkoutId')
            dispatch('createCheckout')
          }
          console.log('existing checkout > ', checkout)
          commit('setCheckout', checkout)
        }, err => {
          console.error(err)
          console.error('Fetch checkout by ID failed. Creating new...')
          localStorage.removeItem('checkoutId')
          dispatch('createCheckout')
        })
      }
      // else, create new
      return shop.checkout.create().then((checkout) => {
        // save id for future retrieving
        localStorage.setItem('checkoutId', checkout.id)
        commit('setCheckout', checkout)
        console.log('New Cart created.')
      }, err => console.error('Create new checkout failed.', err))
    },
    addToCart ({ commit, state }, variantId) {
      if (!state.checkout.id) return false
      const lineItemsToAdd = [{ variantId: variantId, quantity: 1 }]
      shop.checkout.addLineItems(state.checkout.id, lineItemsToAdd).then((checkout) => {
        commit('setCheckout', checkout)
      })
    },
    updateCartItem ({ commit, state }, data) {
      if (!state.checkout.id) return false
      const error = !data.id || typeof data.quantity === 'undefined' // because quantity can be 0 !
      if (error) return Promise.reject(new Error('Empty data.id or data.quantity'))
      const lineItemsToUpdate = [{ id: data.id, quantity: data.quantity }]
      shop.checkout.updateLineItems(state.checkout.id, lineItemsToUpdate).then((checkout) => {
        commit('setCheckout', checkout)
      })
    },
    removeCartItems ({ commit, state }, lineItemIds) {
      // collect all items for removal if none specified
      if (!lineItemIds) {
        lineItemIds = []
        for (var i = 0; i < state.checkout.lineItems.length; i++) {
          lineItemIds.push(state.checkout.lineItems[i].id)
        }
      }
      // remove
      shop.checkout.removeLineItems(state.checkout.id, lineItemIds).then((checkout) => {
        commit('setCheckout', checkout)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js